import en from './en.js';
import sv from './sv.js';

export default { en: en, sv: sv };
